/* eslint-env jest */
import {
  getSessionLunchWindow,
  isWithinLunch,
  resolveLunchStart,
  lunchStartOffsetHours,
  MAX_LUNCH_START_OFFSET_HOURS,
} from './lunchWindow';

test('resolveLunchStart keeps a time later in the day on the check-in day', () => {
  const checkin = new Date('2026-07-09T09:00:00');
  const resolved = resolveLunchStart(checkin, new Date('2000-01-01T12:00:00'));
  expect(resolved.getDate()).toBe(9);
  expect(resolved.getHours()).toBe(12);
});

test('resolveLunchStart rolls a time at or before check-in to the next day', () => {
  const checkin = new Date('2026-07-09T20:00:00');
  const resolved = resolveLunchStart(checkin, new Date('2000-01-01T00:00:00'));
  expect(resolved.getDate()).toBe(10);
  expect(resolved.getHours()).toBe(0);
});

test('lunchStartOffsetHours measures from check-in across midnight', () => {
  const checkin = new Date('2026-07-09T20:00:00');
  // midnight is 4h into an 8PM shift
  expect(lunchStartOffsetHours(checkin, new Date('2000-01-01T00:00:00'))).toBe(
    4
  );
  // 6AM on a 7AM day shift resolves 23h out -- beyond the allowed window
  expect(
    lunchStartOffsetHours(
      new Date('2026-07-09T07:00:00'),
      new Date('2000-01-01T06:00:00')
    )
  ).toBeGreaterThan(MAX_LUNCH_START_OFFSET_HOURS);
});

test('non-deployed uses 12-1PM of the check-in day', () => {
  const { lunchStart, lunchEnd } = getSessionLunchWindow(
    new Date('2026-07-09T09:00:00'),
    1
  );
  expect(lunchStart.getHours()).toBe(12);
  expect(lunchEnd.getHours()).toBe(13);
});

test('deployed uses the stored lunchstart + 1h', () => {
  const ls = '2026-07-10T01:00:00';
  const { lunchStart, lunchEnd } = getSessionLunchWindow(
    new Date('2026-07-09T20:00:00'),
    3,
    ls
  );
  expect(lunchStart.getHours()).toBe(1);
  expect(lunchEnd.getTime()).toBe(lunchStart.getTime() + 3.6e6);
});

test('isWithinLunch is true inside the window, false outside', () => {
  const start = new Date('2026-07-10T01:00:00');
  const end = new Date('2026-07-10T02:00:00');
  expect(isWithinLunch(new Date('2026-07-10T01:30:00'), start, end)).toBe(true);
  expect(isWithinLunch(new Date('2026-07-10T03:00:00'), start, end)).toBe(
    false
  );
});
